export default __webpack_public_path__ + "static/media/qantas-business-rewards.3564e8e0.svg";